import { format } from 'date-fns'

/**
 * Demo page showing four timeline divider style options
 * Access at: /demo/timeline-dividers (add route temporarily to test)
 */

const demoDate = new Date()
const formattedDate = format(demoDate, 'd MMMM yyyy')
const displayText = `TODAY · ${formattedDate}`

// Style 1: Current (Sharp Chevron)
function CurrentChevron() {
  return (
    <div className="relative flex items-center justify-center py-4">
      <div className="flex-1 h-[2px] bg-red-500" />
      <div className="w-0 h-0 border-t-[14px] border-t-transparent border-b-[14px] border-b-transparent border-r-[12px] border-r-red-500" />
      <div className="px-4 py-1 bg-red-500 mx-[1px]">
        <span className="text-sm font-semibold text-white whitespace-nowrap">
          {displayText}
        </span>
      </div>
      <div className="w-0 h-0 border-t-[14px] border-t-transparent border-b-[14px] border-b-transparent border-l-[12px] border-l-red-500" />
      <div className="flex-1 h-[2px] bg-red-500" />
    </div>
  )
}

// Style 2: Pill/Capsule (Modern, Clean)
function PillCapsule() {
  return (
    <div className="relative flex items-center justify-center py-4">
      <div className="flex-1 h-[2px] bg-red-500" />
      <div className="px-5 py-1.5 bg-red-500 rounded-full">
        <span className="text-sm font-semibold text-white whitespace-nowrap">
          {displayText}
        </span>
      </div>
      <div className="flex-1 h-[2px] bg-red-500" />
    </div>
  )
}

// Style 3: Curved Ribbon (SVG with Bezier)
function CurvedRibbon() {
  return (
    <div className="relative flex items-center justify-center py-4">
      <div className="flex-1 h-[2px] bg-red-500" />
      <div className="relative flex items-center">
        {/* Left curved end */}
        <svg width="16" height="32" viewBox="0 0 16 32" className="fill-red-500">
          <path d="M16 0 L16 32 L4 32 Q0 28 0 16 Q0 4 4 0 Z" />
        </svg>
        <div className="px-4 py-1.5 bg-red-500 -mx-[1px]">
          <span className="text-sm font-semibold text-white whitespace-nowrap">
            {displayText}
          </span>
        </div>
        {/* Right curved end */}
        <svg width="16" height="32" viewBox="0 0 16 32" className="fill-red-500">
          <path d="M0 0 L0 32 L12 32 Q16 28 16 16 Q16 4 12 0 Z" />
        </svg>
      </div>
      <div className="flex-1 h-[2px] bg-red-500" />
    </div>
  )
}

// Style 4: Curved Ribbon with Pointed Tips (SVG Bezier)
function CurvedPointed() {
  return (
    <div className="relative flex items-center justify-center py-4">
      <div className="flex-1 h-[2px] bg-red-500" />
      <div className="relative flex items-center">
        {/* Left curved pointed end */}
        <svg width="20" height="32" viewBox="0 0 20 32" className="fill-red-500">
          <path d="M20 0 L20 32 Q8 28 0 16 Q8 4 20 0 Z" />
        </svg>
        <div className="px-3 py-1.5 bg-red-500 -mx-[1px]">
          <span className="text-sm font-semibold text-white whitespace-nowrap">
            {displayText}
          </span>
        </div>
        {/* Right curved pointed end */}
        <svg width="20" height="32" viewBox="0 0 20 32" className="fill-red-500">
          <path d="M0 0 L0 32 Q12 28 20 16 Q12 4 0 0 Z" />
        </svg>
      </div>
      <div className="flex-1 h-[2px] bg-red-500" />
    </div>
  )
}

// Style 5: Notched Bookmark (V-cut inward)
function NotchedBookmark() {
  return (
    <div className="relative flex items-center justify-center py-4">
      <div className="flex-1 h-[2px] bg-red-500" />
      <div className="relative flex items-center">
        {/* Left notched end */}
        <svg width="12" height="32" viewBox="0 0 12 32" className="fill-red-500">
          <polygon points="12,0 12,32 0,32 6,16 0,0" />
        </svg>
        <div className="px-4 py-1.5 bg-red-500 -mx-[1px]">
          <span className="text-sm font-semibold text-white whitespace-nowrap">
            {displayText}
          </span>
        </div>
        {/* Right notched end */}
        <svg width="12" height="32" viewBox="0 0 12 32" className="fill-red-500">
          <polygon points="0,0 0,32 12,32 6,16 12,0" />
        </svg>
      </div>
      <div className="flex-1 h-[2px] bg-red-500" />
    </div>
  )
}

// Style 6: Soft Chevron (rounded points)
function SoftChevron() {
  return (
    <div className="relative flex items-center justify-center py-4">
      <div className="flex-1 h-[2px] bg-red-500" />
      <div className="relative flex items-center">
        {/* Left soft chevron */}
        <svg width="14" height="32" viewBox="0 0 14 32" className="fill-red-500">
          <path d="M14 0 L14 32 L6 32 Q4 32 2 28 L0 20 Q-1 16 0 12 L2 4 Q4 0 6 0 Z" />
        </svg>
        <div className="px-3 py-1.5 bg-red-500 -mx-[1px]">
          <span className="text-sm font-semibold text-white whitespace-nowrap">
            {displayText}
          </span>
        </div>
        {/* Right soft chevron */}
        <svg width="14" height="32" viewBox="0 0 14 32" className="fill-red-500">
          <path d="M0 0 L0 32 L8 32 Q10 32 12 28 L14 20 Q15 16 14 12 L12 4 Q10 0 8 0 Z" />
        </svg>
      </div>
      <div className="flex-1 h-[2px] bg-red-500" />
    </div>
  )
}

export default function TimelineDividerDemo() {
  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Timeline Divider Styles</h1>
        <p className="text-gray-600 mb-8">Compare different styling approaches for the date divider component.</p>

        <div className="space-y-8">
          {/* Current */}
          <div className="bg-white rounded-lg p-6 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-700 mb-1">Current: Sharp Chevron</h2>
            <p className="text-sm text-gray-500 mb-4">CSS border triangles - geometric, dated feel</p>
            <CurrentChevron />
          </div>

          {/* Option 1: Pill */}
          <div className="bg-white rounded-lg p-6 shadow-sm border-2 border-green-200">
            <div className="flex items-center gap-2 mb-1">
              <h2 className="text-lg font-semibold text-gray-700">Option 1: Pill/Capsule</h2>
              <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs font-medium rounded">Recommended</span>
            </div>
            <p className="text-sm text-gray-500 mb-4">Fully rounded ends - cleanest, most modern. Simple CSS.</p>
            <PillCapsule />
          </div>

          {/* Option 2: Curved Ribbon */}
          <div className="bg-white rounded-lg p-6 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-700 mb-1">Option 2: Curved Ribbon</h2>
            <p className="text-sm text-gray-500 mb-4">SVG bezier curves - soft, elegant, premium feel</p>
            <CurvedRibbon />
          </div>

          {/* Option 3: Curved Pointed */}
          <div className="bg-white rounded-lg p-6 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-700 mb-1">Option 3: Curved Pointed</h2>
            <p className="text-sm text-gray-500 mb-4">SVG bezier with pointed tips - keeps directional feel but softer</p>
            <CurvedPointed />
          </div>

          {/* Option 4: Notched Bookmark */}
          <div className="bg-white rounded-lg p-6 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-700 mb-1">Option 4: Notched Bookmark</h2>
            <p className="text-sm text-gray-500 mb-4">V-cut inward like gift ribbon - classic, intentional</p>
            <NotchedBookmark />
          </div>

          {/* Option 5: Soft Chevron */}
          <div className="bg-white rounded-lg p-6 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-700 mb-1">Option 5: Soft Chevron</h2>
            <p className="text-sm text-gray-500 mb-4">Rounded chevron points - keeps arrow motif, less harsh</p>
            <SoftChevron />
          </div>
        </div>

        <div className="mt-8 p-4 bg-blue-50 rounded-lg">
          <h3 className="font-semibold text-blue-900 mb-2">Notes</h3>
          <ul className="text-sm text-blue-800 space-y-1">
            <li>• <strong>Pill/Capsule</strong> is the safest modern choice - works universally</li>
            <li>• <strong>Curved Pointed</strong> maintains the timeline/flow metaphor with sophistication</li>
            <li>• <strong>Notched Bookmark</strong> is distinctive but may feel like a different UI pattern</li>
            <li>• All SVG versions scale perfectly and can be easily colour-themed</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
